import { StyleSheet } from 'react-native';
import theme from '../../common/theme';
import { ThemeColors } from '../../common/theme-colors';

export const getStyles = (colors: ThemeColors) =>
  StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.elevation1,
    },
    btnClose: {
      position: 'absolute',
      top: 16,
      left: 16,
    },
    content: {
      width: 480,
      rowGap: 60,
      alignItems: 'center',
    },
    title: {
      width: '100%',
      fontSize: 28,
      lineHeight: 44,
      textAlign: 'center',
      color: colors.text,
      fontVariant: ['tabular-nums'],
      fontFamily: theme.fonts.semibold,
    },
    form: {
      width: '100%',
      rowGap: 10,
    },
    actions: {
      width: '100%',
      rowGap: 16,
    },
    error: {
      fontSize: 14,
      lineHeight: 20,
      color: colors.red,
      textAlign: 'center',
      fontFamily: theme.fonts.medium,
    },
  });
